import {ReceiptExpensesType} from "@/enums/type";

export class ReceiptPickingListParams {
    page = 1;
    limit = 20;
    type = ReceiptExpensesType.PickingListCollect;
    targetType?: number;
    targetRowGuid?: string;
    createdByRowGuid?: string;
    fromDate?: number;
    toDate?: number;
}